import { LanguageValueObject } from '../kernel/Models/LanguageValueObject';
import { SortValueObject } from '../kernel/Models/SortValueObject';
import { isBrowser } from '@web/js';
export default (() => {
  const ENV = (isBrowser ? window.ENV : process.env) || 'development';
  const BASE = {
    API_URL: ENV.API_URL,
    API_LEGACY_URL: ENV.API_LEGACY_URL,
    API_AUTH_URL: ENV.API_AUTH_URL,
    APP_ENV: ENV.APP_ENV,
    AMPLITUDE_KEY: ENV.AMPLITUDE_KEY,
    CDN_ASSETS_URL: ENV.CDN_ASSETS_URL,
    CDN_DOMESTIKA_URL: ENV.CDN_DOMESTIKA_URL,
    CDN_URL: ENV.CDN_URL,
    CULTURES: LanguageValueObject.cultures,
    CREDENTIALS_COOKIE_NAME: '_credentials_',
    DEFAULT_LANG: 'es',
    APP_URL: ENV.APP_URL,
    GRAPHQL_URL: ENV.GRAPHQL_URL,
    VERSION: ENV.VERSION,
    RESOURCES: {
      ALERTS: 'alert',
      AREAS: 'area',
      BLOG_POSTS: 'blog-post',
      CARTS: 'cart',
      CATEGORIES: 'category',
      CONTENT_ITEMS: 'content-item',
      COURSES: 'course',
      DEVICES: 'device',
      FOLLOWINGS: 'following',
      GUEST_USER: 'guestUser',
      JWT: 'jwt',
      LIVE_CHANNELS: 'live-channel',
      LIVE_FEEDBACK_QUESTIONS: 'live-feedback-question',
      LIVE_FEEDBACK_ANSWERS: 'live-feedback-answer',
      LIVE_SESSIONS: 'live-session',
      LIVE_STREAMS: 'live-stream',
      ORDERS: 'order',
      ORGANIZATIONS: 'organization',
      PLUS_PROMOTIONS: 'promotion-popover',
      PROMOTIONS: 'navigation-banner',
      PROMOTION_CODE_ALERT: 'promotionCodeAlert',
      PUBNUB: 'pubnub',
      SESSION_DATA: 'session-data',
      SOFTWARE: 'software',
      USERS: 'user',
      USER_LIVE_SESSIONS: 'user-live-session',
      VIDEOS: 'video',
      VIDEO_PROGRESSES: 'video-progresses'
    },
    RESOURCES_URL: {
      ALERTS: 'alerts',
      AREAS: 'areas',
      BLOG_POSTS: 'blog-posts',
      CARTS: 'carts',
      CATEGORIES: 'categories',
      CONTENT_ITEMS: 'content-items',
      COURSES: 'courses',
      GUEST_USER: 'guest-users',
      LIVE_FEEDBACK_QUESTIONS: 'live-feedback-questions',
      LIVE_FEEDBACK_ANSWERS: 'live-feedback-answers',
      LIVE_SESSIONS: 'live-sessions',
      LIVE_STREAMS: 'live-streams',
      LIVE_CHANNELS: 'live-channels',
      ORDERS: 'orders',
      PROMOTIONS: 'navigation-banners',
      PLUS_PROMOTIONS: 'promotion-popovers',
      PROMOTION_CODE_ALERT: 'promotion-code-alert',
      PUBNUB: 'pubnub',
      SESSION_DATA: 'session-data',
      SOFTWARE: 'software',
      USERS: 'users',
      ORGANIZATIONS: 'organizations',
      FOLLOWINGS: 'followings',
      DEVICES: 'devices',
      USER_LIVE_SESSIONS: 'user-live-sessions',
      VIDEOS: 'videos',
      VIDEO_PROGRESSES: 'video-progresses'
    },
    ALGOLIA: {
      APP_ID: ENV.ALGOLIA_APP_ID,
      API_KEY: ENV.ALGOLIA_API_KEY
    },
    COOKIES: {
      GDPR_NAME: 'cookies-advise-shown',
      GDPR_ADVANCE_NAME: 'cookies-gdpr-set',
      GDPR_ADVANCE_ANALYTICS_NAME: 'gdpr_analytics',
      GDPR_ADVANCE_PUBLICITY_NAME: 'gdpr_publicity',
      GDPR_VALUE: '1',
      GDPR_EXPIRATION: 1825,
      // 5 years
      GDPR_PATH: ''
    },
    SORT_ORDER: SortValueObject.ORDER
  };
  BASE.RESOURCES_VERSION = {
    [BASE.RESOURCES.ALERTS]: '1',
    [BASE.RESOURCES.AREAS]: '1',
    [BASE.RESOURCES.BLOG_POSTS]: '1',
    [BASE.RESOURCES.CARTS]: '1',
    [BASE.RESOURCES.CATEGORIES]: '1',
    [BASE.RESOURCES.CONTENT_ITEMS]: '1',
    [BASE.RESOURCES.COURSES]: '1',
    [BASE.RESOURCES.GUEST_USER]: '1',
    [BASE.RESOURCES.JWT]: '1',
    [BASE.RESOURCES.LIVE_SESSIONS]: '1',
    [BASE.RESOURCES.LIVE_STREAMS]: '1',
    [BASE.RESOURCES.LIVE_CHANNELS]: '1',
    [BASE.RESOURCES.ORDERS]: '1',
    [BASE.RESOURCES.PROMOTIONS]: '1',
    [BASE.RESOURCES.PROMOTION_CODE_ALERT]: '1',
    [BASE.RESOURCES.SESSION_DATA]: '1',
    [BASE.RESOURCES.SOFTWARE]: '1',
    [BASE.RESOURCES.USERS]: '1',
    [BASE.RESOURCES.FOLLOWINGS]: '1',
    [BASE.RESOURCES.DEVICES]: '1',
    [BASE.RESOURCES.PUBNUB]: '1',
    [BASE.RESOURCES.USER_LIVE_SESSIONS]: '1'
  };
  return BASE;
});